import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ContactModal from "../ContactModal";

function Hero() {
    return (
            <section className="banner-section-three -type-12 banner-lahalle">
                <div className="bg-image">
                    <figure className="main-image wow fadeInRight" data-wow-delay="1500ms">
                        <LazyLoadImage src="/images/lahalle/hotline-handicap-2.webp"
                                       alt="LaHalle"
                                       effect="blur
                                       "/>
                    </figure>
                </div>

                <div className="auto-container hero-lahalle btn-lahalle">
                    <div className="row content-hero-lahalle">
                        <div className="content-column col-lg-12 col-md-12 col-sm-12">
                            <div className="inner-column mt-50">
                                <div className="title-box wow fadeInUp mb-3 raleway">
                                    <h1>
                                        <span>HOTLINE</span>
                                        HANDICAP
                                    </h1>
                                    <div className="text">
                                        Un espace d'échange<br/> confidentiel et anonyme<br/> pour nos collaborateurs
                                    </div>
                                </div>

                                <ContactModal textButton="Prenez RDV  avec un expert"
                                              showText={false}
                                              small=""
                                              linkPageContact={false}
                                              iframe={true}
                                              couleur={true}
                                              page="lahalle"
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Hero;
